// extracted by mini-css-extract-plugin
module.exports = {"container":"Udmkk3a7fsoQrdcCTxWCh"};